const ise2026 = (() => {

    // SELECTOR
    const SELECTOR = {
        kv: '.ise-2026__kv',
        kvText: '.ise-2026__kv .kv-content',
        kvObject: '.ise-2026__kv .kv-object',
        gallery: '.ise-2026__gallery .sc-gallery',

        fadeEffect: '.is-hidden-default, .is-hidden-up'
    }

    // KvFrame
    const kvFrame = (() => {
        const saveStyle = () => [`${SELECTOR.kvObject}, ${SELECTOR.kvText}`];

        const setup = () => gsap.timeline({
            scrollTrigger: {
                trigger: SELECTOR.kv,
                start: 'top top',
                end: '+=1000',
                scrub: true,
                ease: 'none',
                pin: true,
                invalidateOnRefresh: true
                // markers: true,
            }
        })
        .to(
            SELECTOR.kvObject, 
            { opacity: 0.3 }
        )
        .to(
            SELECTOR.kvText, 
            { opacity: 1 },
            0.2
        );

        return {saveStyle, setup};
    })();

    // gallery
    const gallery = (() => {

        const saveStyle = () => [`${SELECTOR.gallery}`];

        const gallery = document.querySelector(`${SELECTOR.gallery}`);
        const galleryItems = gallery.querySelectorAll('.sc-gallery__item');
        const galleryLength = galleryItems.length;

        const gauge = document.querySelector('.swiper-gauge');
        gallery.style.setProperty('--length', galleryLength);
        gauge.dataset.length = galleryLength;
        const gaugeLength = 100 / gauge.dataset.length;

        let gallerySwiper = null;

        const setupPC = () => gsap.to('.sc-gallery__list', {
            xPercent: -100,
            x: () => {
                // -100%만큼 좌측으로 보내서 아예 없앤 후 보여질 만큼만 우측으로 다시 당김
                // 0.864583 -> .sc-gallery의 여백인 13.5417vw 제외한 부분을 당기기 위한 작업
                return document.body.offsetWidth * 0.864583;
            },
            ease: 'none',
            scrollTrigger: {
                trigger: '.sc-gallery',
                start: '11% top',
                end: '89% bottom',
                scrub: 2,
                invalidateOnRefresh: true,
                // invalidateOnRefresh : 반응형에 따라 값 재계산 해주는 옵션
                onUpdate: (self) => {
                    gsap.to('.swiper-gauge', {
                        '--gauge': (self.progress * (100 - gaugeLength)) + gaugeLength,
                    });
                },
            },
        });

        const swiperSetting = (boolean) => {
            if (boolean) {
                // 스와이퍼 셋팅
                gallerySwiper = new Swiper('.sc-gallery .swiper', {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    navigation: {
                        prevEl: '.sc-gallery .swiper-btn--prev',
                        nextEl: '.sc-gallery .swiper-btn--next',
                    },
                    scrollbar: {
                        el: '.sc-gallery .swiper-gauge',
                        draggable: true,
                    },
                });
            } else if (!boolean && gallerySwiper) {
                // 스와이퍼 삭제
                gallerySwiper.destroy(true, true);
                gallerySwiper = null;
            }
        };

        return {saveStyle, setupPC, swiperSetting};
    })();

    // fadeEffect
    const fadeEffect = (() => {
        const setup = () => ScrollTrigger.batch(SELECTOR.fadeEffect, {
            start: 'top bottom',
            // markers: true,
            invalidateOnRefresh: true,
            onEnter: (batch) => {
                // ScrollTrigger.refresh();
                batch.forEach(item => {
                    item.classList.add('is-visible');
                });
            },
            onLeaveBack: (batch) => {
                // ScrollTrigger.refresh();
                batch.forEach(item => {
                    item.classList.remove('is-visible');
                });
            }
        });

        return { setup };
    })();

    // saveStyle
    const saveStyles = () => {
        const allStyles = [
            ...kvFrame.saveStyle(),
            ...gallery.saveStyle()
        ];
        ScrollTrigger.saveStyles(allStyles);
    }
    
    const init = () => {

        gsap.registerPlugin(ScrollTrigger);

        saveStyles();

        ScrollTrigger.matchMedia({

            
            // all
            all: () => {

                fadeEffect.setup();

            },

            // mobile
            '(max-width: 750px)': () => {
                gallery.swiperSetting(true);                
            },

            // pc
            '(min-width: 751px)': () => {
                gallery.setupPC();
                gallery.swiperSetting(false);
            }

        });

    }

    return {
        init: () => {
            init();
        }
    }

})();

document.addEventListener("DOMContentLoaded", function () {
    ise2026.init();
});